import type { Radian } from "@pdfking/math"
import { Asin, Min } from "@pdfking/math"

/** A board that never opens, `board` long, standing off a spine `spine`
 * long till it meets its twin over it, a desk calendar's base: how far past
 * square its fold turns, its share of the angle the two meet at. */
export const StandingMeet = (spine: number, board: number): Radian =>
  Asin(Min(1, spine / 2 / board)) as Radian
